import { computed, inject, toValue } from "vue";
import { keyCanvasDimensions, keyNetId } from "./netCanvasInjectionKeys";
import { useNetCoords } from "./netCoordsModifier";

import type { MaybeRefOrGetter } from "vue";

export function useCanvasDimensions() {
  const canvasDimensionsInject = inject(keyCanvasDimensions);
  const netIdInjected = inject(keyNetId);

  const canvasDimensions = computed(() => canvasDimensionsInject?.value);
  const netId = computed(() => netIdInjected?.value || "");

  const { toLocal, toGlobal, toViewport } = useNetCoords({
    canvasDimensions
  });

  function toGlobalComputed(point: MaybeRefOrGetter<{ x: number; y: number }>) {
    return computed(() => toGlobal(toValue(point)));
  }

  function toViewportComputed(point: MaybeRefOrGetter<{ x: number; y: number }>) {
    return computed(() => toViewport(toValue(point)));
  }

  return {
    canvasDimensions,
    netId,
    toLocal,
    toGlobal,
    toViewport,
    toGlobalComputed,
    toViewportComputed
  }
}
